module.exports = __webpack_public_path__ + "media/images/players/BLAND_RICHARD-5fb089afc5cfacd8a117a19cdc98798f.png";